//import bcrypt from 'bcryptjs';

import md5 from "md5";


const encryptPassword = async (password) => {
    try {
        //const salt = await bcrypt.genSalt(10); // Genera un "salt" (número de rondas de hash)
        //const hashedPassword = await bcrypt.hash(password, salt);
        const hashedPassword = md5(password)
        return hashedPassword;
    } catch (error) {
        console.error('Error al encriptar la contraseña:', error);
        throw error;
    }

};

export default encryptPassword